export const ADVENTURES_GET = 'ADVENTURES_GET';
export const ADVENTURE_DELETE = 'ADVENTURES_DELETE';
